import { c as _c } from "react/compiler-runtime";
import { Modal, PrimaryButton } from '@systemeio/ui';
import { ConnectInfoIntegration } from 'modules/profile/integrations/components/connect-info-integration';
import { ItemIntegration } from 'modules/profile/integrations/components/item-integration';
import { WrapperIntegration } from 'modules/profile/integrations/components/wrapper-integration';
import { WrapperIntegrationSkeleton } from 'modules/profile/integrations/components/wrapper-integtation-skeleton';
import { useGoogleIntegrations } from 'modules/profile/integrations/google/hooks/use-google-integrations';
import { useIntegrateGoogle } from 'modules/profile/integrations/google/hooks/use-integrate-google';
import { IntegrationInterface, IntegrationUseCaseEnum } from 'modules/profile/integrations/google/types';
import { getHelpPageLinkGoogleSheets } from 'modules/profile/integrations/utils/get-help-page-link-google-sheets';
import { useState } from 'react';
import ConfirmationModal from 'shared/components/confirmation-modal';
import TransLoco from 'shared/components/trans-loco';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { useModal } from 'shared/hooks/use-modal';
import useUser from 'shared/hooks/use-user';
import { dateTimeFormat } from 'shared/utils/date-time-format';
import { hasMultipleUseCases } from './utils/has-multiple-use-cases';
import { GoogleSheetsIcon } from '@systemeio/ui/icons';
export const GoogleSheetsIntegrationComingSoon = () => {
  const $ = _c(8);
  const {
    t
  } = useLocoTranslation();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <GoogleSheetsIcon />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("dashboard.user_settings.integrations_page.google_sheets.name");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t) {
    t2 = t("dashboard.user_settings.integrations_page.google_sheets.subtitle-2");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <WrapperIntegration icon={t0} title={t1} subTitle={t2} isComingSoon={true} />;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export const GoogleSheetsIntegration = () => {
  const $ = _c(32);
  const {
    user
  } = useUser();
  const {
    t
  } = useLocoTranslation();
  const [opened, setOpened] = useState(false);
  const removeModal = useModal(false, false);
  const {
    openGoogleLogin,
    openGoogleLoginToReconnect,
    isFetching
  } = useIntegrateGoogle({
    onSuccess: handleIntegrationSuccess
  });
  const {
    getIntegrationsByUseCase,
    removeIntegration,
    mutate,
    mutateIntegrationsWithNewItem
  } = useGoogleIntegrations();
  const data = getIntegrationsByUseCase(IntegrationUseCaseEnum.Spreadsheets);
  async function handleIntegrationSuccess(item) {
    await mutateIntegrationsWithNewItem(item);
  }
  let t0;
  if ($[0] !== mutate || $[1] !== removeIntegration || $[2] !== removeModal) {
    t0 = async function handleRemove(integration) {
      if (hasMultipleUseCases(integration) && !removeModal.opened) {
        removeModal.open(integration);
        return;
      }
      await removeIntegration(integration.id);
      await mutate();
    };
    $[0] = mutate;
    $[1] = removeIntegration;
    $[2] = removeModal;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const handleRemove = t0;
  let t1;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = function handleOpenModal() {
      setOpened(true);
    };
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleOpenModal = t1;
  let t2;
  if ($[5] !== openGoogleLogin) {
    t2 = async function openLogin() {
      await openGoogleLogin(IntegrationUseCaseEnum.Spreadsheets);
      setOpened(false);
    };
    $[5] = openGoogleLogin;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const openLogin = t2;
  let t3;
  if ($[7] !== mutate || $[8] !== openGoogleLoginToReconnect) {
    t3 = async function handleReconnect(item_0) {
      await openGoogleLoginToReconnect(item_0.id, item_0.googleUserEmail);
      await mutate();
    };
    $[7] = mutate;
    $[8] = openGoogleLoginToReconnect;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const handleReconnect = t3;
  const isConnected = data?.items.some(_temp) ?? false;
  const t4 = data ? <><WrapperIntegration icon={<GoogleSheetsIcon />} title={t("dashboard.user_settings.integrations_page.google_sheets.name")} subTitle={t("dashboard.user_settings.integrations_page.google_sheets.subtitle-2")} onClick={handleOpenModal} isConnect={isConnected} /><Modal title={t("dashboard.user_settings.integrations_page.google_sheets.title")} onClose={() => setOpened(false)} opened={opened}><>{data.items.length !== 0 ? <div className="flex flex-col"><div>{data.items.map(item_1 => <ItemIntegration key={item_1.id} email={item_1.googleUserEmail} status={item_1.disconnectedAt ? t("global.expired") : t("global.active")} createdAt={dateTimeFormat(item_1.createdAt, {
              timeFormat: user?.timeFormat,
              dateFormat: user?.dateFormat,
              timeZone: user?.timezone
            })} removeIntegration={() => handleRemove(item_1)} showReconnectButton={!!item_1.disconnectedAt} reconnectIntegration={() => handleReconnect(item_1)} />)}</div><div className="flex justify-center"><PrimaryButton width="small" onClick={openLogin} isFetching={isFetching}>{t("dashboard.user_settings.integrations_page.google_sheets.add_account")}</PrimaryButton></div></div> : <ConnectInfoIntegration isFetching={isFetching} href={getHelpPageLinkGoogleSheets(user?.dashboardLocale)} handleOpenIntegrationLogin={openLogin} infoText="dashboard.user_settings.integrations_page.google_sheets_integration.help" />}</></Modal></> : <WrapperIntegrationSkeleton />;
  let t5;
  if ($[10] !== removeModal) {
    t5 = () => removeModal.cleanData();
    $[10] = removeModal;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== removeModal) {
    t6 = () => removeModal.close();
    $[12] = removeModal;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== handleRemove || $[15] !== removeModal.data) {
    t7 = () => removeModal.data && handleRemove(removeModal.data);
    $[14] = handleRemove;
    $[15] = removeModal.data;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const t8 = removeModal.data?.googleUserEmail;
  let t9;
  if ($[17] !== t8) {
    t9 = {
      account_address: t8
    };
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      b: <b />
    };
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t || $[21] !== t9) {
    t11 = <TransLoco t={t} i18nKey="dashboard.user_settings.integrations_page.google_sheets.delete_confirmation" values={t9} components={t10} />;
    $[20] = t;
    $[21] = t9;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== removeModal.opened || $[24] !== t11 || $[25] !== t5 || $[26] !== t6 || $[27] !== t7) {
    t12 = <ConfirmationModal afterLeave={t5} opened={removeModal.opened} onClose={t6} onConfirm={t7} confirmationText={t11} />;
    $[23] = removeModal.opened;
    $[24] = t11;
    $[25] = t5;
    $[26] = t6;
    $[27] = t7;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t12 || $[30] !== t4) {
    t13 = <>{t4}{t12}</>;
    $[29] = t12;
    $[30] = t4;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  return t13;
};
function _temp(integration_0) {
  return !integration_0.disconnectedAt;
}